export function initEnquirePage() {
    // Only run on enquire page
    if (!document.querySelector('.enquire-page')) return;
    
    console.log('Enquire page JavaScript loaded');
    
    const container = document.querySelector('.enquire-page__container');
    const step1 = document.getElementById('step-1');
    const step2 = document.getElementById('step-2');
    const nextBtn = document.getElementById('next-btn');
    const stateButtons = document.querySelectorAll('.enquire-page__state-btn');
    const managersContainer = document.getElementById('managers-list');
    const hubspotContainer = document.getElementById('hubspot-form-container');
    
    console.log('Found', stateButtons.length, 'state buttons');
    
    let selectedState = null;
    
    // State selection handling
    stateButtons.forEach(button => {
        button.addEventListener('click', function() {
            console.log('State button clicked:', this.dataset.state);
            
            // Remove active class from all buttons
            stateButtons.forEach(btn => btn.classList.remove('active'));
            
            // Add active class to clicked button
            this.classList.add('active');
            
            // Store selected state
            selectedState = this.dataset.state;
            
            // Enable next button
            nextBtn.disabled = false;
            nextBtn.classList.add('enabled');
            
            console.log('Selected state:', selectedState);
        });
    });
    
    // Next button handling
    nextBtn.addEventListener('click', function() {
        if (selectedState) {
            transitionToStep2();
        }
    });
    
    function transitionToStep2() {
        // Start the transition by fading out step 1
        step1.style.opacity = '0';
        step1.style.transform = 'translateY(-20px)';
        
        // Add step-2 class to container to trigger teal panel expansion
        container.classList.add('step-2');
        
        // Load step 2 content
        loadStep2Content();
        
        // After step 1 fades out, show step 2
        setTimeout(() => {
            step1.classList.remove('active');
            step2.classList.add('active');
            
            // Fade in the left content of step 2
            const leftContent = step2.querySelector('.enquire-page__left');
            leftContent.style.opacity = '0';
            leftContent.style.transform = 'translateY(20px)';
            
            // Animate left content fade in
            setTimeout(() => {
                leftContent.style.opacity = '1';
                leftContent.style.transform = 'translateY(0)';
            }, 100);
            
            // Slide in the right panel after a short delay
            setTimeout(() => {
                const rightPanel = step2.querySelector('.enquire-page__right');
                rightPanel.classList.add('slide-in');
            }, 300);
            
        }, 300);
    }
    
    function loadStep2Content() {
        // Load sales managers for selected state
        loadSalesManagers(selectedState);
        
        // Load HubSpot form for selected state
        loadHubSpotForm(selectedState);
    }
    
    function loadSalesManagers(state) {
        const managers = window.swcEnquiryData.salesManagers[state] || [];
        
        managersContainer.innerHTML = '';
        
        managers.forEach(manager => {
            const managerElement = document.createElement('div');
            managerElement.className = 'enquire-page__manager';
            
            let avatarHtml = '';
            if (manager.image_url) {
                avatarHtml = `<div class="enquire-page__manager-avatar">
                    <img src="${manager.image_url}" alt="${manager.image_alt || manager.name}" />
                </div>`;
            }
            
            managerElement.innerHTML = `
                ${avatarHtml}
                <div class="enquire-page__manager-info">
                    <h4 class="enquire-page__manager-name">${manager.name}</h4>
                    <p class="enquire-page__manager-title">${manager.position || manager.title || 'Sales Manager'}</p>
                    ${manager.phone ? `<p class="enquire-page__manager-phone">${manager.phone}</p>` : ''}
                    ${manager.email ? `<p class="enquire-page__manager-email"><a href="mailto:${manager.email}">${manager.email}</a></p>` : ''}
                </div>
            `;
            managersContainer.appendChild(managerElement);
        });
    }
    
    function loadHubSpotForm(state) {
        // The HubSpot form is already embedded in the HTML
        // Just log that we're loading it for this state
        console.log('HubSpot form ready for state:', state);
    }
}